import React, { useState } from "react";

export default function AddNewUser() {
    const [fullname, setFullname] = useState("");
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [messageType, setMessageType] = useState("success"); // or "danger"

    const showMessage = (text, type = "success") => {
        setMessage(text);
        setMessageType(type);
        setTimeout(() => setMessage(""), 4000); // auto-hide after 4 seconds
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Client-side validation
        const errors = [];

        if (!fullname.trim()) errors.push("Full Name is required.");
        if (!username.trim()) errors.push("Username is required.");
        if (!password) errors.push("Password is required.");
        else if (password.length < 6) errors.push("Password must be at least 6 characters.");

        if (errors.length > 0) {
            showMessage(errors.join(" "), "danger");
            return;
        }

        setLoading(true);
        const token = sessionStorage.getItem("token");
        try {
            const res = await fetch(`${process.env.REACT_APP_BASE_URL}cc/r/users/create`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    "Authorization": `Bearer ${token}`,
                },
                body: JSON.stringify({
                    fullname,
                    username,
                    password,
                }),
            });

            const data = await res.json();

            if (!res.ok) {
                if (data.errors) {
                    const messages = Object.values(data.errors).flat().join(" ");
                    showMessage(messages, "danger");
                } else {
                    showMessage("Failed to create user.", "danger");
                }
            } else {
                showMessage("User created successfully.", "success");
                setFullname("");
                setUsername("");
                setPassword("");
            }
        } catch (err) {
            console.error(err);
            showMessage("An error occurred while creating user.", "danger");
        }

        setLoading(false);
    };

    return (
        <div>
            <h2 className="text-center mb-2 mt-4">Add New User</h2>
            <form className="d-flex flex-column align-items-center mt-4" onSubmit={handleSubmit}>
                <input
                    type="text"
                    placeholder="Full Name"
                    className="inputPrimary p-2 mb-3 border"
                    value={fullname}
                    maxLength={50}
                    minLength={3}
                    onChange={(e) => {
                        const value = e.target.value;
                        if (/^[a-zA-Z\s]*$/.test(value)) {
                            setFullname(value);
                        }
                    }}
                />
                <input
                    type="username"
                    placeholder="Usersname"
                    className="inputPrimary p-2 mb-3 border"
                    maxLength={16}
                    minLength={3}
                    value={username}
                    onChange={(e) => {
                        const value = e.target.value;
                        if (/^[a-zA-Z0-9.-]*$/.test(value)) {
                            setUsername(value)
                        }
                    }}
                />
                <input
                    type="password"
                    placeholder="Password"
                    className="inputPrimary p-2 mb-4 border"
                    value={password}
                    maxLength={16}
                    minLength={8}
                    onChange={(e) => setPassword(e.target.value)}
                />
                <button className="px-4 py-2 btnPrimary mx-auto" type="submit" disabled={loading}>
                    {loading ? "Creating..." : "Create User"}
                </button>
            </form>

            {/* On-screen message */}
            {message && (
                <div className={`alert alert-${messageType} text-center mt-3`} role="alert">
                    {message}
                </div>
            )}
        </div>
    );
}
